module.exports = "https://assets.localphysio.net.au/_next/static/images/map-icon-334b225ff49be64813fac7499696cef0.png";